const noticeSource = {
  ENRCRT: 'Enrolment - create',
  ENRUPD: 'Enrolment - update',
  SSRCRT: 'Session report - create',
  SSRUPD: 'Session report – update',
  FDCEXM: 'FDC Exemption',
  ACCTMG: 'Account Management',
  ACCSCW: 'ACCS Child Wellbeing',
  PAYMNT: 'Payment',
  RTNFEE: 'Return Fee Reduction',
  ENTTLM: 'Entitlement',
  CAREPV: 'Care Provided and Vacancy',
  DEBTMG: 'Debt Management',
}

const noticeTypes = {
  IMMED: 'Immediate action required',
  ERROR: 'An error has occurred',
  WARNIG: 'Warning only',
  INFO: 'Information only',
}

export const messageSubject = code => noticeSource[code] || code

export const isCriticalNoticeType = code => ['IMMED', 'ERROR'].includes(code)

export const messageType = code => noticeTypes[code] || code



// WEBPACK FOOTER //
// ./src/ui/gov-messages/helpers.jsx